"use client";

import { useState } from "react";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";

export default function CopyLink({ id }) {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopy = async () => {
        const url = `${window.location.origin}${window.location.pathname}#${id}`;
        try {
            await navigator.clipboard.writeText(url);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        } catch (err) {
            console.error("Erreur lors de la copie du lien :", err);
        }
    };

    return (
        <button
            onClick={handleCopy}
            className="ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-gray-400 dark:text-grayDark-500 hover:text-gray-600 dark:hover:text-grayDark-300"
            aria-label="Copier le lien"
        >
            {isCopied ? (
                <SolarIcon name="unread-linear" className="w-4 h-4 text-green-500" />
            ) : (
                <SolarIcon name="link-round-angle-linear" className="w-4 h-4" />
            )}
        </button>
    );
}
